import {
  IInsurance,
  ILicense,
  IEmissions
} from '../models/compliance.interface';

export interface IComplianceStore {
  // Insurance section
  insuranceRecords: IInsurance[];
  showInsurancePopup: boolean;
  selectedInsurance: IInsurance | null;

  // Licensing section
  licensingRecords: ILicense[];
  showLicensingPopup: boolean;
  selectedLicense: ILicense | null;

  // Emissions section
  emissionsInfo: IEmissions | null;

  // UI state
  activeSection: 'insurance' | 'licensing' | 'emissions';
  isLoading: boolean;
  error: string | null;
}

export const initialComplianceState: IComplianceStore = {
  // Insurance section
  insuranceRecords: [],
  showInsurancePopup: false,
  selectedInsurance: null,

  // Licensing section
  licensingRecords: [],
  showLicensingPopup: false,
  selectedLicense: null,

  // Emissions section
  emissionsInfo: null,

  // UI state
  activeSection: 'insurance',
  isLoading: false,
  error: null
};
